module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-4-zoom.e7667ef1.png";